export const categories = [
  {
    id: "domestic",
    name: "国内探花",
    slug: "domestic",
    description: "精选国内优质探花内容，涵盖各地特色资源与原创作品",
    metaDescription: "国内探花分类页，汇聚全国各地优质探花内容资源，每日更新精选作品",
    image: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20night%20scene%20with%20warm%20neon%20lights%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style&width=800&height=600&seq=cat-page-domestic&orientation=landscape",
    count: 128,
  },
  {
    id: "selection",
    name: "探花精选",
    slug: "selection",
    description: "人工精选高品质探花作品，严格把关内容质量",
    metaDescription: "探花精选分类页，人工筛选高品质探花内容，为您呈现最值得观看的精品",
    image: "https://readdy.ai/api/search-image?query=Luxury%20golden%20spotlight%20on%20dark%20stage%2C%20elegant%20minimalist%20composition%2C%20premium%20editorial%20style%20photography&width=800&height=600&seq=cat-page-selection&orientation=landscape",
    count: 256,
  },
  {
    id: "tanhua91",
    name: "探花91",
    slug: "tanhua91",
    description: "91探花系列独家聚合，热门资源一站获取",
    metaDescription: "探花91分类页，91探花系列内容聚合，最新热门资源实时更新",
    image: "https://readdy.ai/api/search-image?query=Abstract%20geometric%20shapes%20with%20warm%20coral%20gradients%2C%20modern%20digital%20art%2C%20minimalist%20clean%20composition&width=800&height=600&seq=cat-page-91&orientation=landscape",
    count: 312,
  },
  {
    id: "live",
    name: "探花直播",
    slug: "live",
    description: "实时探花直播频道，热门主播在线互动",
    metaDescription: "探花直播分类页，实时直播频道，热门主播在线互动精彩内容",
    image: "https://readdy.ai/api/search-image?query=Professional%20live%20streaming%20studio%20with%20colorful%20lights%2C%20modern%20minimalist%20design%2C%20editorial%20photography&width=800&height=600&seq=cat-page-live&orientation=landscape",
    count: 64,
  },
  {
    id: "top-master",
    name: "顶级探花大师",
    slug: "top-master",
    description: "行业顶级探花大师作品集，大师级制作水准",
    metaDescription: "顶级探花大师分类页，行业标杆级大师作品集，精品中的精品",
    image: "https://readdy.ai/api/search-image?query=Professional%20film%20director%20chair%20on%20elegant%20dark%20set%2C%20warm%20spotlight%2C%20cinematic%20atmosphere&width=800&height=600&seq=cat-page-master&orientation=landscape",
    count: 48,
  },
  {
    id: "zone1",
    name: "探花一区",
    slug: "zone1",
    description: "探花一区专区，经典内容完整收录",
    metaDescription: "探花一区分类页，经典系列专区，历年优质内容完整收录",
    image: "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20with%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-page-zone1&orientation=landscape",
    count: 198,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};